import { render } from "./FormCheckboxes.vue?vue&type=template&id=525bdcfa&scoped=true"
import script from "./FormCheckboxes.vue?vue&type=script&lang=js"
export * from "./FormCheckboxes.vue?vue&type=script&lang=js"

import "./FormCheckboxes.vue?vue&type=style&index=0&id=525bdcfa&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525bdcfa"]])

export default __exports__